import { ArticleOutlined, PersonOutline } from '@mui/icons-material';
import { Box, MenuItem, Tab, Tabs } from '@mui/material';
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import React, { createContext, useEffect, useState } from 'react'
import SearchInput from '../../components/mini/SearchInput';
import Pagination from '../../components/mini/Pagination';
import { Avatar } from "@mui/material";
import { Link, useParams } from 'react-router-dom';
import StatsOverview from '../../components/StatsOverview';
import { getCustomers } from '../../controllers/user/getCustomers';
import { templateStaff, templateStaffReport } from '../../data/user/staffData';
import { getUsers } from '../../controllers/user/getUsers';
import DotMenu from '../../components/mini/DotMenu';
import { deactivateUser } from '../../controllers/user/deactivateUser';
import { useDispatch, useSelector } from 'react-redux';
import { setAlertMsg } from '../../redux/reducers/modal/snackBarSlice';
import { activateUser } from '../../controllers/user/activateUser';
import downloadCSV from '../../features/utils/downloadCSV';
import { getUser } from '../../controllers/user/getUser';
import ModalLocal from '../../components/mini/ModalLocal';
import { resetStaffPasswordReq } from '../../controllers/user/resetStaffPassword';


const rows = [
  // {
  //   id: 1, customer: '',bookingDate: null,status: ''
  // }
  {
    id: 1, customer: 'Yona',date: '24th Oct, 2023 8:29AM',
    product: "Flight",
    paymentMethod: 'Card Payment',
    amount: 12412, status: 'Pending'
  }
];
[...Array(10-rows.length)].map((o,i) => rows.push({...rows[0],id:i+3}))

const filterItems = [
  {items:[{id: 0,field: 'status',operator: '',value:''}]},
  {items:[{id: 1,field: 'status', operatorValue: 'is', value: 'active'}]},
  {items:[{id: 2,field: 'status', operatorValue: 'is', value: 'inactive'}]},
];


const StatusContext = createContext();

function StatusCol({params,reload}) {
  const {user} = useSelector((state) => state.user.userData);

  const [anchorEl, setAnchorEl] = useState();
  const dispatch = useDispatch();

  async function handleDeActivate() {
    setAnchorEl(null);
    const res = await deactivateUser(params.id);
    if(res.return) {
      reload && reload()
      dispatch(setAlertMsg(['success','Deactivated']))
    } else dispatch(setAlertMsg(['error',res.msg]))
  }
  async function handleActivate() {
    setAnchorEl(null);
    const res = await activateUser(params.id);
    if(res.return) {
      reload && reload()
      dispatch(setAlertMsg(['success','Activated']))
    } else dispatch(setAlertMsg(['error',res.msg]))
  }
  
  
  if(user?.type === 'CORPORATE')
    return (
      <StatusContext.Consumer>
        {(value) => {
          const {handleReset} = value || {}
          return (
            <div className='flex justify-between w-full relative'>
              <p className="flex-1 overflow-hidden overflow-ellipsis" title={params.value}>
                {params.value}
              </p>
              <DotMenu anchor={anchorEl} setAnchor={setAnchorEl} parentControl={true} >
                <MenuItem><Link to={`/staff/detail/${params.id}`}>View Detail</Link></MenuItem>
                <MenuItem onClick={() => handleReset(params?.row)}>Reset Password</MenuItem>
              </DotMenu>
            </div>
          )
        }}

      </StatusContext.Consumer>
    )


  
  return (
    <div className='flex justify-between w-full relative'>
      <p className="flex-1 overflow-hidden overflow-ellipsis" title={params.value}>
        {params.value}
      </p>
      <DotMenu anchor={anchorEl} setAnchor={setAnchorEl} parentControl={true} >
        <MenuItem><Link to={`/staff/detail/${params.id}`}>View Detail</Link></MenuItem>
        {params.value === 'Active' ? 
          <MenuItem onClick={handleDeActivate}>Deactivate</MenuItem>
        :
          <MenuItem onClick={handleActivate}>Activate</MenuItem>
        }
      </DotMenu>

    </div>
  )
}


export default function Index() {
  const {user} = useSelector((state) => state.user.userData);
  const [data,setData] = useState([]);
  const {type} = useParams();
  const [loading,setLoading] = useState(false);
  const [filter,setFilter] = useState(filterItems[0]);
  const [paginationModel,setPaginationModel] = useState({pageSize: 25,page: 0})
  // const [rowId,setRowId] = useState(null);
  const [openReset,setOpenReset] = useState(false);
  const [resetLoading,setResetLoading] = useState(false);
  const apiRef = useGridApiRef();
  var [fetchedData,setFetchedData] = useState(null);

  const dispatch = useDispatch();
  
  useEffect(() => {
    console.log(type);
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  async function load() {
    setLoading(true);
    let params = {
      isAdmin: true
    }
    let res = {return: 0, msg: '0XCRPSTF'}; 
    if(user?.type === 'CORPORATE')
      res = await getUser('me');
    else
      res = await getUsers((new URLSearchParams(params)).toString());
    setLoading(false);
    if(res.return) {
      let data = [];
      if(user?.type === 'CORPORATE')
        data = res?.data?.corporateStaffUsers || []
      else
        data = res.data
      data = data.map((row) => templateStaff(row))
      setFetchedData(data);
      setData(data);
    }
  }

  const columns = [
    {field: 'firstName',headerName: 'First Name',flex:1,
      renderCell: (params) => {
        if(!params.value) return null;
        return (
          <div className='flex gap-4 items-center'>
            <Avatar>{params.value[0]}</Avatar>
            {params.value}
          </div>
        )
      }
    },
    {field: 'lastName',headerName: 'Last Name',flex: 1,
      renderCell: (params) => {
        if(!params.value)
          return null;
  
        return (
          <div className='flex flex-col'>
            {params.value}
          </div>
        )
      }
    },
    {field: 'phone',headerName: 'Phone',minWidth: 170,
      renderCell: (params) => {
        if(!params.value) return null;
        return (
          <div className='flex flex-col '>
            {params.value}
          </div>
        )
      }
    },
    {field: 'email', headerName: 'Email', flex: 1, minWidth: 200,
      renderCell: (params) => {
        if(!params.value) return null;
        
        return (
          <div className='flex flex-col gap-0'>
            <b className='!font-normal'>{params.value}</b>
          </div>
        )
      },
    },
    {field: 'role',headerName: 'Role',flex: 1,minWidth: 130,
      renderCell: (params) => {
        if(!params.value)
        return null;
  
        return (
          <div className='flex justify-between w-full relative'>
            <p className="flex-1 overflow-hidden overflow-ellipsis" title={params.value}>
              {params.value}
            </p>
          </div>
        )
      }
    },
    {field: 'status',headerName: 'Status',flex: 1,minWidth: 130,
      renderCell: (params) => {
        if(!params.value)
        return null;
  
        return (
          <StatusCol params={params} reload={load} />
        )
      }
    },
  ];
  
  function handleSearch(val) {
    setData(fetchedData);

    val = val.toLowerCase();
    setData(data => data.filter(obj => (
      obj.firstName.toLowerCase().includes(val) ||
      obj.lastName.toLowerCase().includes(val) ||
      obj.status.includes(val)
    )))
  }

  function generateReport(data,columns) {
    
    // Prepend the column headers to the CSV data
    const csvData = data.map((row) => templateStaffReport(row));
    csvData.unshift([...columns,
      {field: 'createdDate',headerName: 'Created Date'},
      {field: 'updatedDate',headerName: 'Updated Date'},
    ].map(col => col.headerName));

    // console.log('csvData', csvData)

    downloadCSV(csvData,'Staff')
  }

  async function handleReset() {
    setResetLoading(true)
    const res = await resetStaffPasswordReq({email: openReset?.email});
    setResetLoading(false)
    if(res?.return) {
      dispatch(setAlertMsg(['success','Reset password sent to staff email']))
      setOpenReset()
    } else dispatch(setAlertMsg(['error',res.msg]))
  }
  
  
  return (
    <div className='w-full p-4 m-2'>
      <div className='pb-4'>
        <StatsOverview />
      </div>
      <div className='flex gap-4 justify-between items-center my-3'>
        <Tabs value={filter.items[0].id} onChange={(ev,newVal) => setFilter(filterItems[newVal])} 
         variant='scrollable'
         scrollButtons={false}
         className='shadow-md'>
          <Tab label={"All ("+data.length+")"} />
        </Tabs>
        <SearchInput className='text-theme1' onChange={handleSearch} />
        <div className='flex flex-wrap gap-2'>
          <Link to="/staff/create" className='btn1 rounded-md !bg-[#1C2E3A] whitespace-nowrap'><PersonOutline /> Create Staff</Link>
          <button className='btn2 whitespace-nowrap' onClick={() => generateReport(data,columns)}><ArticleOutlined /> Generate Report</button>
        </div>
      </div>
      <StatusContext.Provider value={{handleReset: setOpenReset}}>
        <Box className=''>
          <DataGrid rows={data} columns={columns} loading={loading} autoHeight hideFooter={false}
            // getRowId={(row) => row.id}
            apiRef={apiRef}
            initialState={{
              sorting: {
                sortModel: [{field: "bookingDate",sort: 'desc'}]
              },
            }}
            filterModel={filter}
            onFilterModelChange={(newFilter) => setFilter(newFilter)}
            
            // slots={{pagination: Pagination}}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}

            // onCellEditStart={params => setRowId(params.id)}
            // hideFooterPagination
            checkboxSelection
          />
          <Pagination perPage={10} total={46} apiRef={apiRef} />
        </Box>
      </StatusContext.Provider>

      <ModalLocal open={openReset} setOpen={setOpenReset}>
        <div className='bg-secondary p-4 flex flex-col gap-4'>
          <h3 className='py-4'>Are you sure you want to reset password for<br /> <p className='text-primary/60'>{openReset?.email}</p></h3>
          <div className='flex gap-4 items-center justify-between'>
            <button className='btn1_outlined' onClick={() => setOpenReset()}>Cancel</button>
            <button className='btn2' onClick={handleReset} disabled={resetLoading}>{resetLoading ? <div className='load'></div> : 'Confirm'}</button>
          </div>
        </div>
      </ModalLocal>
    </div>
  )
}
